
import { defineComponent } from "vue";
import ButtonStory from "../stories/ButtonStory.vue";
import AccordionStory from "../stories/AccordionStory.vue";
import GithubIco from "../components/GithubIco.vue";

export default defineComponent({
    name: "DemoPage",
    components: {
        ButtonStory,
        AccordionStory,
        GithubIco,
    },
    inject: ['isThemeInverse']
});
